import { render, staticRenderFns } from "./deliverysetupDetails.vue?vue&type=template&id=0ba3587d&scoped=true&"
import script from "./deliverysetupDetails.vue?vue&type=script&lang=js&"
export * from "./deliverysetupDetails.vue?vue&type=script&lang=js&"
import style0 from "./deliverysetupDetails.vue?vue&type=style&index=0&id=0ba3587d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3587d",
  null
  
)

export default component.exports